(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc-heritage-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sc-heritage-catalog'))customElements.define('sc-heritage-catalog',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const buttons=[...this.querySelectorAll('[data-filter]')],cards=[...this.querySelectorAll('[data-groups]')];this.querySelector('.heritage-catalog__filters').hidden=false;buttons.forEach(button=>button.addEventListener('click',()=>{const selected=button.dataset.filter;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let visible=0;cards.forEach(card=>{card.hidden=selected!=='all'&&!card.dataset.groups.split(' ').includes(selected);if(!card.hidden)visible++;});this.querySelector('.heritage-catalog__empty').hidden=visible>0;},{signal:this.controller.signal}));}
disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-heritage-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-heritage-slideshow')) {
  customElements.define('sc-heritage-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.querySelector('.sc-hero-slideshow__controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1),opts);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),opts);
      this.querySelector('[data-toggle]').addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},opts);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},opts);
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}},opts);
      document.addEventListener('visibilitychange',()=>this.schedule(),opts);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.schedule();},opts);
      document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.show(i);}},opts);
      this.addEventListener('touchstart',e=>{this.startX=e.changedTouches[0].clientX;this.startY=e.changedTouches[0].clientY;},{...opts,passive:true});
      this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.startX;const dy=e.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));},{...opts,passive:true});
      this.schedule();
    }
    show(index) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.inert=i!==this.index;});
      this.querySelector('[data-counter]').textContent=`${this.index+1} / ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const b=this.querySelector('[data-toggle]');
      b.textContent=this.paused?'▶':'Ⅱ';
      b.setAttribute('aria-label',this.paused?b.dataset.play:b.dataset.pause);
      if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||7000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-product-slides"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-product-slides')) {
  customElements.define('sc-product-slides', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.sc-slides__track');this.slides=[...this.querySelectorAll('.sc-slides__slide')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hover=false;this.focused=false;
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.querySelector('.sc-slides__controls')?.removeAttribute('hidden');
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),opts);
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),opts);
      this.pauseButton=this.querySelector('[data-pause]');
      this.pauseButton?.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();},opts);this.updatePause();
      this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);const status=this.querySelector('[data-status]');if(status)status.textContent=`${this.index+1} / ${this.slides.length}`;},opts);
      this.addEventListener('mouseenter',()=>this.hover=true,opts);this.addEventListener('mouseleave',()=>this.hover=false,opts);
      this.addEventListener('focusin',()=>this.focused=true,opts);this.addEventListener('focusout',e=>this.focused=this.contains(e.relatedTarget),opts);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.indexOf(e.target);if(i>=0){this.paused=true;this.updatePause();this.track.scrollTo({left:i*this.track.clientWidth,behavior:'instant'});}},opts);
      if(this.dataset.autoplay==='true' && this.slides.length>1)this.timer=setInterval(()=>{if(!this.paused&&!this.hover&&!this.focused&&!document.hidden)this.move(1);},Number(this.dataset.interval));
    }
    updatePause(){if(this.pauseButton){this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;this.pauseButton.setAttribute('aria-pressed',String(this.paused));}}
    move(delta){const i=(this.index+delta+this.slides.length)%this.slides.length;this.track.scrollTo({left:i*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
